import type { TimelineNode } from "@/mocks/events";
import { formatDate } from "@/lib/eventUtils";

const typeTone: Record<string, string> = {
  "事件发生": "bg-primary-100 text-primary-800",
  "官方回应": "bg-accent-100 text-accent-800",
  "结论": "bg-secondary-200 text-secondary-900",
};

export default function Timeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <ol className="relative mt-2">
      {nodes.map((node, index) => {
        const isLast = index === nodes.length - 1;
        return (
          <li key={`${node.date}-${index}`} className="relative pl-8 md:pl-10 pb-8 last:pb-0">
            {!isLast && (
              <span className="absolute left-[7px] md:left-[9px] top-4 bottom-0 w-px bg-background-300" />
            )}
            <span
              className={`absolute left-0 top-1.5 w-[15px] h-[15px] md:w-[19px] md:h-[19px] rounded-full border-2 flex items-center justify-center ${
                isLast
                  ? "border-accent-500 bg-accent-100"
                  : "border-primary-400 bg-background-50"
              }`}
            >
              <span
                className={`w-1.5 h-1.5 md:w-2 md:h-2 rounded-full ${
                  isLast ? "bg-accent-600" : "bg-primary-500"
                }`}
              />
            </span>

            <div className="flex flex-wrap items-center gap-2 md:gap-3">
              <time className="font-heading text-sm font-bold text-foreground-950" dateTime={node.date}>
                {formatDate(node.date)}
              </time>
              <span
                className={`text-[11px] px-2 py-0.5 rounded-full ${
                  typeTone[node.type] ?? "bg-secondary-100 text-secondary-800"
                }`}
              >
                {node.type}
              </span>
            </div>
            <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900">{node.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
          </li>
        );
      })}
    </ol>
  );
}